import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
  isOpen: boolean;
  onToggle: () => void;
}
function AccordionItem({
  title,
  children,
  isOpen,
  onToggle
}: AccordionItemProps) {
  return <div className="border-b border-[#EBE5DB] last:border-b-0" data-id="element-120">
      <button onClick={onToggle} className="w-full flex items-center justify-between py-4 text-left text-[#5C4A3A] hover:text-[#3D3229] transition-colors" data-id="element-121">
        <span className="text-sm font-medium" data-id="element-122">{title}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} data-id="element-123">
          <ChevronDown size={16} data-id="element-124" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-125">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-126">
            <div className="pb-4 text-sm text-[#5C4A3A]/70 leading-relaxed" data-id="element-127">
              {children}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function LegalFooter() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <footer className="py-16 px-4 bg-[#F5F0E8]" data-id="element-128">
      <div className="max-w-2xl mx-auto" data-id="element-129">
        <div className="bg-white rounded-2xl border border-[#EBE5DB] px-6" data-id="element-130">
          <AccordionItem title="Política de privacidad" isOpen={openIndex === 0} onToggle={() => toggle(0)} data-id="element-131">
            <p className="mb-3" data-id="element-132">
              [Texto legal placeholder] En cumplimiento con la normativa vigente
              en materia de protección de datos personales, le informamos que
              los datos personales recogidos a través de este sitio web serán
              tratados de forma confidencial.
            </p>
            <p className="mb-3" data-id="element-133">
              Sus datos serán utilizados únicamente para gestionar su compra y
              enviarle información relacionada con el producto adquirido. No se
              cederán datos a terceros salvo obligación legal.
            </p>
            <p data-id="element-134">
              Puede ejercer sus derechos de acceso, rectificación, cancelación y
              oposición contactando a través del correo electrónico
              proporcionado. Este texto será reemplazado por la política de
              privacidad definitiva.
            </p>
          </AccordionItem>

          <AccordionItem title="Aviso legal" isOpen={openIndex === 1} onToggle={() => toggle(1)} data-id="element-135">
            <p className="mb-3" data-id="element-136">
              [Texto legal placeholder] Este sitio web es propiedad de [Nombre
              del titular]. La información contenida en esta página tiene
              carácter informativo y comercial.
            </p>
            <p className="mb-3" data-id="element-137">
              El titular no se hace responsable del uso indebido de los
              contenidos y se reserva el derecho de actualizarlos o eliminarlos
              en cualquier momento.
            </p>
            <p data-id="element-138">
              Queda prohibida la reproducción total o parcial de los contenidos
              sin autorización expresa. Este texto será reemplazado por el aviso
              legal definitivo.
            </p>
          </AccordionItem>

          <AccordionItem title="Términos y condiciones" isOpen={openIndex === 2} onToggle={() => toggle(2)} data-id="element-139">
            <p className="mb-3" data-id="element-140">
              [Texto legal placeholder] Al adquirir este producto digital, usted
              acepta los presentes términos y condiciones de compra.
            </p>
            <p className="mb-3" data-id="element-141">
              El producto consiste en un pack de 10 e-books en formato digital
              con acceso inmediato tras la confirmación del pago. Se ofrece una
              garantía de devolución de 30 días desde la fecha de compra.
            </p>
            <p data-id="element-142">
              Los contenidos están protegidos por derechos de autor y su
              distribución no autorizada está prohibida. Este texto será
              reemplazado por los términos y condiciones definitivos.
            </p>
          </AccordionItem>
        </div>

        <p className="text-center text-xs text-[#5C4A3A]/50 mt-8" data-id="element-143">
          © {new Date().getFullYear()} Hogar Bienestar. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}